import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["editable", "input"];

  disconnect() {
    if (this.inputElement != null) {
      this.removeInput();
    }
  }

  edit() {
    if (this.inputElement != null) {
      return;
    }

    this.inputElement = this.hasInputTarget
      ? this.inputTarget
      : document.createElement("input");
    this.initialValue = this.inputElement.value = this.editableTarget.innerText;

    const style = window.getComputedStyle(this.editableTarget);
    this.inputElement.style.cssText = style.cssText;

    const selection = window.getSelection();
    if (this.editableTarget.contains(selection.anchorNode)) {
      let start = selection.anchorOffset;
      let end = selection.focusOffset;
      if (start > end) {
        [start, end] = [end, start];
      }
      this.inputElement.setSelectionRange(start, end);
    } else {
      this.inputElement.setSelectionRange(0, this.inputElement.value.length);
    }

    if (!this.hasInputTarget) {
      this.editableTarget.insertAdjacentElement("afterend", this.inputElement);
    }
    this.element.classList.add("edit-inline__editing");
    this.inputElement.focus();
  }

  async complete(e) {
    if (this.inputElement == null) {
      return;
    }
    e.preventDefault();
    const value = this.inputElement.value;
    this.removeInput();
    if (value == this.initialValue) {
      return;
    }

    if (this.element.nodeName === "FORM") {
      const form = this.element;
      const response = await fetch(form.action, {
        method: form.method,
        body: new URLSearchParams(new FormData(form)),
      });
      if (response.ok) {
        this.editableTarget.innerText = value;
        this.editableTarget.title = value;
        this.editableTarget.setAttribute("data-original-title", value);
        this.dispatchChangeEvent(value);
      }
    } else {
      this.dispatchChangeEvent(value);
    }
  }

  dispatchChangeEvent(value) {
    this.dispatch("change", { detail: { value } });
  }

  cancel(e) {
    if (this.inputElement == null) {
      return;
    }
    if (this.focusMovingToRelatedElement(e)) {
      return;
    }
    e.preventDefault();
    this.removeInput();
  }

  focusMovingToRelatedElement(e) {
    return (
      (e.type == "focusout" || e.type == "blur") &&
      this.element.contains(e.relatedTarget)
    );
  }

  removeInput() {
    this.element.classList.remove("edit-inline__editing");
    // prevent re-entrant call through focusout when element removed
    const inputElement = this.inputElement;
    this.inputElement = null;
    if (!this.hasInputTarget) {
      inputElement.remove();
    }
  }
}
